import { type FragmentOf, graphql, readFragment } from "@opensea/graphql"
import type { ButtonProps } from "@opensea/ui-kit"
import type { ComponentProps } from "react"
import {
  bestItemOfferFragment,
  getItemBestOffer,
} from "@/lib/fragments/best-order"
import { TokenPrice } from "../price/TokenPrice"
import { AcceptOfferButton } from "./AcceptOfferButton"
import { useAcceptOffers } from "./use-accept-offers"
import { useAcceptOffersFragment } from "./use-accept-offers.fragment"

export const SellItemTableButtonFragment = graphql(
  `
    fragment SellItemTableButton on Item {
      ...bestItemOffer
      ...useAcceptOffers
    }
  `,
  [useAcceptOffersFragment, bestItemOfferFragment],
)

type Props = {
  item: FragmentOf<typeof SellItemTableButtonFragment>
  display?: ComponentProps<typeof TokenPrice>["display"]
} & ButtonProps

export function SellItemTableButton({
  item: itemKey,
  size = "xs",
  display = "standard",
  ...rest
}: Props) {
  const item = readFragment(SellItemTableButtonFragment, itemKey)
  const { disabledReason, disabled, acceptOffers } = useAcceptOffers([
    { ...item, quantity: 1 },
  ])

  const bestOffer = getItemBestOffer(item)

  if (!bestOffer) {
    return <TokenPrice display={display} price={null} />
  }

  return (
    <AcceptOfferButton
      disabled={disabled}
      disabledReason={disabledReason}
      display={display}
      makerAddress={bestOffer.maker.address}
      onAccept={() => acceptOffers()}
      pricePerItem={bestOffer.pricePerItem}
      size={size}
      {...rest}
    />
  )
}
